<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3">
          <el-tooltip
            placement="top"
            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
              <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>

          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_site") }}</h5>
          <p class="mb-0">{{ $t("introduction_job_site_assignee") }}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("add_task") }} :</strong> {{ $t("add_task_detail") }}</li>
            <li><strong>{{ $t("attach_document") }} :</strong> {{ $t("attach_document_detail") }}</li>
            <li><strong>{{ $t("assign_user") }} :</strong> {{ $t("assign_user_detail") }}</li>
            <li><strong>{{ $t("print") }} :</strong> {{ $t("print_detail") }}</li>
            <li><strong>{{ $t("site_induction_tasks") }} :</strong> {{ $t("site_induction_tasks_detail") }}</li>

          </ul>
        </div>
      </div>
    </div>
    <div class="vertical-tab">
      <div class="row">
        <div class="col-md-3 pr-md-3 tab-menu">
          <div class="card card-with-shadow border-0">
            <div class="header-icon">
              <div class="icon-position d-flex justify-content-center">
                <div
                  class="
                    tab-icon
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                >
                  <app-icon name="link" />
                </div>
              </div>
            </div>
            <div class="px-primary py-primary">
              <div
                class="nav flex-column nav-pills"
                role="tablist"
                aria-orientation="vertical"
              >
              <app-overlay-loader v-if="preloader" />
              <p class="text-center" v-if="sites.length == 0">This job no site</p>
                <div v-for="(site, index) in sites"
                  :key="index">
                    <a v-if="site.type == 0"
                        style="
                            border-bottom: 0px;
                            border-color: transparent;
                            cursor: pointer;"
                        class="
                            text-capitalize
                            tab-item-link
                            d-flex
                            justify-content-between
                            my-2 my-sm-3"
                        data-toggle="pill"
                        @click.prevent="stiteList(site.id)">
                        <span>{{ site.title }}</span>
                        <span class="active-icon"><app-icon name="chevron-right"/></span>
                    </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-9 pl-md-3 pt-md-0 pt-sm-4 pt-4">
  
          <myjob-index-site-list
            v-if="isSiteList"
            :id="siteId"
            :getJob="getJob"
            :siteid="id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMPANY_JOB_SHOW } from "../../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../../Helpers/AxiosHelper.js";
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";

export default {
  name: "Site",
  mixins: [FormMixin],
  data() {
    return {
      instructionShow: false,
      preloader:true,
      isSiteList: true,
      siteId: 0,
      sites: {},
      id: "",
      site: [],
    };
  },
  methods: {
    instructionOpen() {
      this.$attrs['props'].close(false);
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    stiteList(id) {
      this.siteId = id;
      this.isSiteList = true;
    },
     getJob(id) {
      axiosGet(COMPANY_JOB_SHOW + "/" + id)
        .then((res) => {
          this.job = res.data;
          this.sites = this.job.sites;
          this.preloader = true;
          // let id = this.job.sites[0].id;
          
          let d = this.job.sites.filter((e, i) => {
            let a = e.type == 0;
            return a;
          });
          let id = d;
          if (this.sites.length >0) 
          {
            this.siteId = id[0].id;
          }
        })
        .catch((error) => {
          
        }).finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    // let nsplit = split[7].split("?");
    let id = this.$attrs['props'].id;
    this.id = id;
    this.getJob(id);
    this.sitesreload = true;

    this.$attrs['props'].close(false);

  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
  },
  watch: {
    // whenever question changes, this function will run
    sites: function (newsites, oldsites) {
      // 
      // this.getJob(id);
    },
  },
};
</script>
